import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MetadataHeaderSkeleton = () => {
    const baseColor = "#5e8541";
    const highlightColor = "#79bc77";

    return (
        <div className="sticky top-0 z-10 flex items-center justify-between bg-green-highlight px-6 py-[18px]">
            <div className="flex items-center">
            {/* Icon Skeleton */}
            <Skeleton circle height={18} width={18} className="mr-2" baseColor={baseColor} highlightColor={highlightColor} />

            {/* Metric Name Skeleton */}
            <Skeleton height={20} width={200} baseColor={baseColor} highlightColor={highlightColor} />
            </div>

            {/* Close Button Skeleton */}
            <Skeleton height={18} width={18} baseColor={baseColor} highlightColor={highlightColor} />
        </div>
    );
}

export default MetadataHeaderSkeleton;
